import { useState, useCallback, useEffect, useRef, useContext } from "react";
import Profile from "../RegistrySteps/components/Profile";
import LoginData from "../RegistrySteps/components/LoginData";
import Information from "../RegistrySteps/components/Information";
import Verification from "../RegistrySteps/components/Verification";
import RegisterSuccessScreen from "../RegistrySteps/components/RegisterSuccessScreen";
import * as kUser from "../../../constants/users_login";
import { useLocation } from "react-router-dom";
import useFetch from "../../../hooks/useFetch";
import * as kApi from "../../../constants/api";
import {
  checkIsEqualText,
  get2ndPath,
  getPermitionByURL,
  updateObject,
  getMsgErrorLogin,
} from "../../../helpers";
import ImgProfile from "../../../assets/images/steps/register_step_1_desktop.svg";
import ImgLoginData from "../../../assets/images/steps/register_step_2_desktop.svg";
import ImgInformation from "../../../assets/images/steps/register_step_3_desktop.svg";
import ImgVerification from "../../../assets/images/steps/register_step_4_desktop.svg";
import ImgProfileMb from "../../../assets/images/steps/register_step_1_mobile.svg";
import ImgLoginDataMb from "../../../assets/images/steps/register_step_2_mobile.svg";
import ImgInformationMb from "../../../assets/images/steps/register_step_3_mobile.svg";
import ImgVerificationMb from "../../../assets/images/steps/register_step_4_mobile.svg";
import { Auth } from "aws-amplify";
import { useDispatch } from "react-redux";
import * as actions from "../../../store/actions";
import { useNavigate } from "react-router-dom";
import { R_LOGIN } from "../../../constants/routes";
import { setAnalyticsNewRegister } from "../../../helpers/analyticsHelpers";
import * as defaults from "../../../constants/defaults";
import Spinner from "../../../components/UI/Spinner";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";

import SystemContext from "context/SystemContext";
import { Box, Container, Typography } from "@mui/material";

const LOGIN_SCREEN = "LOGIN_SCREEN";

let deferredPrompt;

const CardMain = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let token = window.location?.hash;
  const url = window.location.href;
  const isConfirm = url.includes("confirmacao");
  token = token?.split("=")[1]?.split("&id_token")[0];
  const email = url?.split("confirmacao?email=")[0].split("?email")[1];
  const secondPath = get2ndPath(useLocation().pathname);
  const permissions = getPermitionByURL(secondPath);
  const recaptchaRef = useRef(null);
  const userlogin = location?.state?.login || {};

  const { loginInfo, changePropertyUrl } = useContext(SystemContext);

  const [inviteCode] = useState(
    loginInfo && loginInfo.code ? loginInfo.code : "",
  );
  //!AJUSTAR
  const [step, setStep] = useState(!isConfirm ? "Profile" : "Verification");
  // const [step, setStep] = useState("OpenSpinner");
  const [verifyError, setVerifyError] = useState("");
  const [errorMsg, setErrorMsg] = useState(null);
  const [reload, setReload] = useState(false);
  const [codeResend, setCodeResend] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [resentCodeSuccess, setResentCodeSuccess] = useState("");
  const [resentCodeError, setResentCodeError] = useState("");
  const [session, setSession] = useState({});
  const [signUpForm, setSignUpForm] = useState({
    username: loginInfo && loginInfo.email ? loginInfo.email : "",
    password: "",
    confirm_password: "",
    given_name: "",
    verify_codigo: "",
    phone: "",
    profile: "",
    isLinkedSuccessfully: false,
    [kUser.CUSTOM_BIRTH_DATE]: "",
    [kUser.CUSTOM_OCCUPATION]: "",
    [kUser.CUSTOM_START_ACC_TYPE]: permissions,
    [kUser.CUSTOM_INVITE_CODE]: inviteCode,
  });
  useEffect(() => {
    if (email) {
      setSignUpForm({
        ...signUpForm,
        username: email,
      });
    }
  }, []);

  const [login, setLogin] = useState(signUpForm);
  const isLoading = step === "OpenSpinner";

  useEffect(() => {
    const tipoMap = {
      professional: "profissional",
      patient: "paciente",
      personal: "pessoal",
    };
    const slug = tipoMap[signUpForm.profile] || "";
    if (step === "Profile") {
      changePropertyUrl("/cadastro");
    } else if (step === "LoginData") {
      if (slug) changePropertyUrl(`/cadastro/${slug}/dados`);
    } else if (step === "Information") {
      if (slug) changePropertyUrl(`/cadastro/${slug}/dados/informacoes`);
    } else if (step === "Verification") {
      if (slug) changePropertyUrl(`/cadastro/${slug}/dados/informacoes/codigo`);
    } else if (step === "Success") {
      if (slug)
        changePropertyUrl(
          `/cadastro/${slug}/dados/informacoes/codigo/obrigado`,
        );
    }
  }, [step, signUpForm.profile]);

  useEffect(() => {
    setSession({
      given_name: signUpForm.given_name,
      email: signUpForm.username,
    });
  }, [signUpForm]);

  const [parent, parent_isFetching, parent_error, fetchParent] = useFetch({
    autoInit: false,
    noAuth: true,
  });

  useEffect(() => {
    if (verifyError === null) {
      setStep("OpenSpinner");
    }
    if (inviteCode)
      fetchParent({
        url: kApi.API_Q_CODE + "/" + inviteCode,
        onSuccess: () => {
          setStep("LoginData");
          setSignUpForm({
            ...signUpForm,
            profile: t(`global.profile_paciente`),
          });
        },
        onError: () => {
          setStep("Profile");
        },
      });
  }, [inviteCode]);

  const onChange = (event) => {
    let { value, name } = event.target;
    if (checkIsEqualText(name, kUser.CUSTOM_INVITE_CODE)) {
      value = value.replace(/[^a-zA-Z]+/g, "").toUpperCase();
    } else if (checkIsEqualText(name, kUser.VERIFY_CODIGO)) {
      value = value.replace(/[^0-9]+/g, "").toUpperCase();
    } else if (checkIsEqualText(name, "username")) {
      value = value.toLowerCase();
    } else if (checkIsEqualText(name, "phone")) {
      value = value.replaceAll(/[\s()-]/g, "").replace(/\D/g, "");
    } else if (checkIsEqualText(name, kUser.CUSTOM_BIRTH_DATE)) {
      value = value.toUpperCase();
    }
    setSignUpForm(updateObject(signUpForm, { [name]: value }));
  };

  const setErrorMsgHandler = (error = null, spinner = false) => {
    setSpinner(spinner);
    if (error && error.code) setErrorMsg(getMsgErrorLogin(error.code));
    else setErrorMsg(null);
  };

  // HANDLER DE LOGIN
  const loginActionHandler = async (event) => {
    if (event) event.preventDefault();
    setErrorMsgHandler(null, true);
    let data = {
      username: signUpForm.username
        ? signUpForm.username
        : userlogin.username + "",
      password: signUpForm.password
        ? signUpForm.password
        : userlogin.password + "",
    };
    try {
      const res = await Auth.signIn(data);
      showInstallAlert();
      sessionStorage.setItem("justRegistered", "true");
      dispatch(actions.initSessionActive(res));
      setErrorMsgHandler();
      console.log("sucesso login");
      // navigate(R_REGISTER_SUCCESS);
      return true;
    } catch (errors) {
      setErrorMsgHandler(errors);
      if (errors.code === kUser.USER_NOT_CONFIRMED_EXCEPTION)
        setStep("Verification");
      return false;
    }
  };

  // Nova função para verificar se o usuário já está vinculado, apesar do erro
  const checkIfUserIsLinked = (username, password, origError) => {
    // Primeiro, tentar fazer login para verificar se a conta existe
    Auth.signIn({
      username: username,
      password: password,
    })
      .then((user) => {
        // Se o login for bem-sucedido, agora verificar se o usuário está vinculado com o código de convite
        const token = user.signInUserSession.idToken.jwtToken;

        // Chamar a API para verificar se o usuário está vinculado com o código de convite
        // Você pode precisar implementar este endpoint no seu backend
        fetch(`${kApi.API_Q_CODE}/check/${inviteCode}`, {
          headers: {
            Authorization: token,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            if (data && data.isLinked) {
              // Usuário está vinculado com sucesso
              setStep("Verification");
              setVerifyError(
                "Invalid code provided, please request a code again.",
              );
              // Definir uma flag para indicar vinculação bem-sucedida, apesar do erro
              setSignUpForm((prev) => ({
                ...prev,
                isLinkedSuccessfully: true,
              }));

              // Inicializar sessão
              dispatch(actions.initSessionActive(user));
            } else {
              // Usuário não está vinculado, mostrar erro normal
              setStep("Verification");
              setVerifyError(origError.message);
            }
          })
          .catch((err) => {
            // Se a verificação da API falhar, voltar para mostrar o erro
            setStep("Verification");
            setVerifyError(origError.message);
          });
      })
      .catch((err) => {
        // Se o login falhar, mostrar o erro original
        setStep("Verification");
        setVerifyError(origError.message);
      });
  };

  const verifyCodigoActionHandler = async (event) => {
    if (event) event.preventDefault();
    setErrorMsgHandler(null, true);
    setStep("OpenSpinner");
    const userName = signUpForm.username
      ? signUpForm.username
      : userlogin.username;
    const verify_codigo = signUpForm.verify_codigo
      ? signUpForm.verify_codigo
      : userlogin.verify_codigo;
    const password = signUpForm.password
      ? signUpForm.password
      : userlogin.password;
    try {
      await Auth.confirmSignUp(userName, verify_codigo);
      if (userName && userName !== "" && password && password !== "") {
        const logado = await loginActionHandler();

        loginActionHandlerToken();
        setAnalyticsNewRegister();
        console.log("if cardsignup");
        return logado;
      } else {
        changeScreenHandler(LOGIN_SCREEN);
        console.log("else cardsignup");
      }
    } catch (errors) {
      setErrorMsgHandler(errors);

      // Verificar se é um erro de "código inválido", mas o usuário pode já estar vinculado
      if (errors.message && errors.message.includes("Invalid code provided")) {
        // Se temos um código de convite, isso pode indicar que o usuário já foi vinculado com sucesso
        if (inviteCode) {
          // Precisamos verificar se o usuário está vinculado, apesar do erro
          checkIfUserIsLinked(userName, password, errors);
        } else {
          setStep("Verification");
          setVerifyError(errors.message);
        }
      } else {
        setStep("Verification");
        setVerifyError(errors.message);
      }
      return false;
    }
  };

  const showInstallAlert = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(function (choiceResult) {});

      deferredPrompt = null;
    }
  };

  const loginActionHandlerToken = (event) => {
    if (event) event.preventDefault();
    if (!token) return;
    setErrorMsgHandler(null, true);
    let data = {
      token: token,
    };

    Auth.signIn(data)
      .then((res) => {
        showInstallAlert();
        dispatch(actions.initSessionActive(res));
        setErrorMsgHandler();
      })
      .catch((errors) => {
        setErrorMsgHandler(errors);
        if (errors.code === kUser.USER_NOT_CONFIRMED_EXCEPTION)
          setStep("Verification");
      });
  };

  const signUpActionHandler = (event) => {
    if (event) event.preventDefault();
    recaptchaRef.current.execute();
  };

  const executeSignUp = () => {
    setStep("OpenSpinner");
    let _signUpUser = {
      username: signUpForm.username,
      password: signUpForm.password,
      attributes: {
        given_name: signUpForm.given_name,
        [kUser.CUSTOM_BIRTH_DATE]: signUpForm[kUser.CUSTOM_BIRTH_DATE],
        [kUser.CUSTOM_OCCUPATION]: signUpForm[kUser.CUSTOM_OCCUPATION],
        [kUser.CUSTOM_START_ACC_TYPE]: signUpForm[kUser.CUSTOM_START_ACC_TYPE],
        [kUser.CUSTOM_START_PLATAFORMA]: defaults.WEB,
        [kUser.CUSTOM_PROFILE]: signUpForm.profile,
        [kUser.CUSTOM_PHONE]: signUpForm.phone,
        [kUser.CUSTOM_REGISTER_SEARCH]: window.location.search,
      },
    };

    if (signUpForm[kUser.CUSTOM_INVITE_CODE]) {
      _signUpUser.attributes = {
        ..._signUpUser.attributes,
        [kUser.CUSTOM_INVITE_CODE]: signUpForm[kUser.CUSTOM_INVITE_CODE],
      };
    }

    Auth.signUp(_signUpUser)
      .then((res) => {
        setErrorMsgHandler();
        setStep("Verification");
        if (window.AmplReferral) {
          window.AmplReferral.identify(
            {
              name: signUpForm.given_name,
              email: signUpForm.username,
            },
            (data) => {},
          );
        }
      })
      .catch((errors) => {
        setErrorMsgHandler(errors);
      });
  };

  const changeScreenHandler = useCallback(
    (screen) => {
      setSignUpForm({ ...signUpForm, password: "" });
      setErrorMsgHandler(null);
      setStep(screen);
      if (screen === LOGIN_SCREEN) navigate(R_LOGIN);
    },
    [navigate, login],
  );

  const resendCode = (event) => {
    if (event) event.preventDefault();
    setErrorMsgHandler(null, true);
    // setStep("OpenSpinner");
    Auth.resendSignUp(
      userlogin.username ? userlogin.username : signUpForm.username,
    )
      .then((res) => {
        setResentCodeSuccess(t("global.verify_code_resend"));
      })
      .catch((errors) => {
        console.log("errors", errors);
        setResentCodeError(t("global.verify_code_resend_error"));
      });
  };

  const flowData = {
    Profile: {
      title: t("global.shall_we_begin_the_registration_process"),
      stepDesk: <img src={ImgProfile} alt="profile" />,
      stepMob: <img src={ImgProfileMb} alt="profile" />,
      component: (
        <Profile
          setStep={setStep}
          signUpForm={signUpForm}
          setSignUpForm={setSignUpForm}
        />
      ),
    },
    LoginData: {
      title: t("global.fill_in_the_details"),
      stepDesk: <img src={ImgLoginData} alt="login data" />,
      stepMob: <img src={ImgLoginDataMb} alt="login data" />,
      component: (
        <LoginData
          setStep={setStep}
          signUpForm={signUpForm}
          onChange={onChange}
          inviteCode={inviteCode}
          parent={parent}
          setReload={setReload}
          reload={reload}
        />
      ),
    },
    Information: {
      title: t("global.we_want_to_know_a_little_more_about_you"),
      stepDesk: <img src={ImgInformation} alt="information" />,
      stepMob: <img src={ImgInformationMb} alt="information" />,
      component: (
        <Information
          setStep={setStep}
          onChange={onChange}
          signUpForm={signUpForm}
          setSignUpForm={setSignUpForm}
          createUser={signUpActionHandler}
          setReload={setReload}
          reload={reload}
        />
      ),
    },
    Verification: {
      title: t("global.We_re_almost_there"),
      stepDesk: <img src={ImgVerification} alt="verification" />,
      stepMob: <img src={ImgVerificationMb} alt="verification" />,
      component: (
        <Verification
          setStep={setStep}
          onChange={onChange}
          signUpForm={signUpForm}
          resendCode={resendCode}
          formSubmit={verifyCodigoActionHandler}
          spinner={spinner}
          verifyError={verifyError}
          setReload={setReload}
          reload={reload}
          codeResend={codeResend}
          setCodeResend={setCodeResend}
          resentCodeSuccess={resentCodeSuccess}
          resentCodeError={resentCodeError}
          isConfirm={isConfirm}
          isLinkedSuccessfully={signUpForm.isLinkedSuccessfully}
          redirectToDashboard={() => setStep("Success")}
        />
      ),
    },
    Success: { component: <RegisterSuccessScreen /> },
    OpenSpinner: {
      component: (
        <Box
          sx={{
            flex: 1,
            width: "100%",
            minHeight: "500px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spinner />
        </Box>
      ),
    },
  };
  const onExpireRecaptcha = (e) => {
    console.log("onExpireRecaptcha", e);
    signUpActionHandler();
  };
  const onErrorRecaptcha = (e) => {
    console.log("onExpireRecaptcha", e);
  };
  const onRecaptchaCorrect = (e) => {
    console.log("onRecaptchaCorrect");
    executeSignUp();
  };

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        boxSizing: "border-box",
      }}
    >
      <ReCAPTCHA
        ref={recaptchaRef}
        size="invisible"
        sitekey={kApi.SECRET_reCAPTCHA}
        isolated={true}
        type="image"
        onErrored={onErrorRecaptcha}
        onChange={onRecaptchaCorrect}
        onExpired={onExpireRecaptcha}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          maxWidth: "1200px",
          minHeight: "700px",
          padding: "1rem",
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            minWidth: "360px",
            minHeight: "700px",

            //Ajusta tamanho do box quando for o sppiner
            ...(isLoading && {
              width: "100%",
              maxWidth: "900px",
            }),

            border: "4px solid #f6a940",
            borderRadius: "10px",
            backgroundColor: "#ffffff",
            padding: "20px",
            overflow: "visible",
            mb: "60px",
            mt: "20px",
          }}
        >
          <Box
            sx={{
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              flex: 1,
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Box
                sx={{
                  margin: "10px 0",
                  display: {
                    xs: "none",
                    sm: "flex",
                  },
                }}
              >
                {flowData[step].stepDesk}
              </Box>
              <Box
                sx={{
                  margin: "10px 0 20px",
                  display: {
                    xs: "flex",
                    sm: "none",
                  },
                }}
              >
                {flowData[step].stepMob}
              </Box>

              <Typography
                sx={{
                  color: "#662D91",
                  fontSize: { xs: "24px", md: "30px" },
                  fontWeight: 700,
                  margin: "15px 0",
                }}
              >
                {flowData[step].title}
              </Typography>
            </Box>
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              {flowData[step].component}
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};
export default CardMain;
